<script>
import { mapActions } from 'vuex';
import request from '@/services/request';
import ModalFormComponent from '@/components/banking_services/ModalBankingServicesComponent.vue';

export default {
    name: "BankingServicesList",
    components: {
        ModalFormComponent,
    },
    data() {
        return {
            load: false,
            rules: [],
            search: {
                company_id: '',
                payable_type_id: '',
            }
        }
    },
    methods: {
        async list(page = 1) {
            this.load = true;
            let service = request;
            let search = this.search;
            let _endpoint = '/banking-service-payment-rules';
            search.search = this.name;
            try {
                let { data } = await service.list(_endpoint, page, search)
                this.rules = data.data;
                this.load = false;
            } catch (error) {
                this.load = false;
                this.errors = {};
                this.errors = await this.errorNotification(error);
            }
        },
        openCreateModal(rule = {}) {
            console.log(rule);
            Event.$emit('event-show-banking-service-payment-rule', rule);
        },
        deleteRule(id) {
            let tit = 'Eliminar regla';
            let txt = 'Seguro que quiere eliminar la regla';

            this.$swal({
                title: tit,
                text: txt,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Eliminar',
                cancelButtonText: 'Cancelar'
            }).then(async (result) => {
                if (result.isConfirmed) {
                    let _endpoint = '/banking-service-payment-rules/' + id;

                    try {
                        let response = await request.destroy(_endpoint).then(function (response) { return response; });
                        this.list();
                        this.successNotification(response.data.message);
                    } catch (error) {
                        this.errors = await this.errorNotification(error)
                    }
                }
            });
        },
        getPayableTypeName(type) {
            const value = parseInt(type);

            if (value === 1) {
                return 'Cuenta bancaria';
            }

            if (value === 2) {
                return 'Proveedor';
            }

            return 'No definido';
        },
        getBankAccountName(rule) {
            if (!rule.bank_account) {
                return 'Cuenta no encontrada';
            }

            let name = rule.bank_account.name + ' - ' + rule.bank_account.number;

            return name;

        },
        ...mapActions({
            resetPassword: 'auth/resetPass',
            errorNotification: 'alert/error',
            successNotification: 'alert/success',
        })
    },
    async mounted() {
        this.loadAll = true;
        this.list();
    },

    created() {
        Event.$on('event-reload-banking-service-payment-rule', async () => {
            this.list();
        });
    }
}
</script>
<template>
    <div>
        <ModalFormComponent />
        <div class="card card-outline card-navy">
            <div class="card-header">
                <h3 class="card-title">
                    Reglas de pago de servicios bancarios
                </h3>
                <div class="card-tools">
                    <button class="btn btn-sm btn-outline-info" @click="openCreateModal">
                        <i class="fa fa-plus"></i>
                        Nueva regla
                    </button>
                </div>
            </div>

            <div class="card-body">


                <!-- <div class="row mb-3">

                    <div class="col-md-4">
                        <label>Tipo de regla</label>
                        <select v-model="search.payable_type_id" class="form-control" @change="getRules">
                            <option value="">Todos</option>
                            <option :value="1">Cuenta bancaria</option>
                            <option :value="2">Proveedor</option>
                        </select>
                    </div>

                    <div class="col-md-4">
                        <label>Empresa</label>
                        <select v-model="search.company_id" class="form-control" @change="getRules">
                            <option value="">Todas</option>
                            <option v-for="company in companies" :key="company.id" :value="company.id">
                                {{ company.name }}
                            </option>
                        </select>
                    </div>

                </div> -->

                <div v-if="loading" class="text-center py-4">
                    <i class="fa fa-spinner fa-spin"></i>
                    Cargando información...
                </div>

                <div v-else class="table-responsive">
                    <table class="table table-bordered text-center text-sm">
                        <thead>
                            <tr>
                                <th>ID</th>
                                <th>Tipo</th>
                                <th>Cuenta / Proveedor</th>
                                <th>Pagos al mes</th>
                                <th>Monto máximo por pago</th>
                                <th>Pago máximo por mes</th>
                                <th width="130">Acciones</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-if="load" class="text-center">
                                <td colspan="9">
                                    <i class="fa-solid fa-circle-notch fa-spin fa-3x mb-1"></i>
                                    <h5>Cargando</h5>
                                </td>
                            </tr>

                            <tr v-else-if="rules.length === 0">
                                <td colspan="9" class="text-center">
                                    No hay reglas registradas.
                                </td>
                            </tr>

                            <tr v-else v-for="rule in rules" :key="rule.id">
                                <td>{{ rule.id }}</td>


                                <td>
                                    <span class="badge"
                                        :class="rule.payable_type_id == 1 ? 'badge-info' : 'badge-secondary'">
                                        {{ getPayableTypeName(rule.payable_type_id) }}
                                    </span>
                                </td>

                                <td>
                                    <template v-if="rule.payable_type_id == 1">
                                        {{ getBankAccountName(rule) }}
                                    </template>

                                    <template v-else-if="rule.payable_type_id == 2">
                                        {{ rule.provider ? rule.provider.name + ' ' + rule.provider.last_name :
                                        'Proveedor no encontrado' }}
                                    </template>

                                    <template v-else>
                                        S/N
                                    </template>
                                </td>

                                <td>
                                    {{ rule.payments_per_month || 'Sin límite' }}
                                </td>

                                <td>
                                    {{ rule.max_amount_per_payment | toCurrency }}
                                </td>

                                <td>
                                    {{ rule.max_amount_per_month | toCurrency }}
                                </td>

                                <td>
                                    <button class="btn m-1 btn-outline-primary btn-sm" @click="openCreateModal(rule)">
                                        <i class="fa fa-edit"></i> Editar
                                    </button>

                                    <button class="btn m-1 btn-outline-danger btn-xs" @click="deleteRule(rule.id)">
                                        <i class="fa fa-trash"></i> Eliminar
                                    </button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>
